import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_brand-hampers-1/artifacts/w4mwc0kw_black%20and%20white%20SH%20logo.png" 
              alt="SwiftHampers Logo" 
              className="h-12 w-auto mb-4"
              data-testid="footer-logo"
            />
            <p className="text-sm text-gray-400">
              Premium corporate gifting & promotional merchandise solutions for modern businesses.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4" data-testid="footer-quick-links-title">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-sm text-gray-400 hover:text-accent transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" data-testid="footer-link-services" className="text-sm text-gray-400 hover:text-accent transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" data-testid="footer-link-products" className="text-sm text-gray-400 hover:text-accent transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-sm text-gray-400 hover:text-accent transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4" data-testid="footer-services-title">Services</h4>
            <ul className="space-y-2">
              <li className="text-sm text-gray-400">Corporate Gifting</li>
              <li className="text-sm text-gray-400">Employee Welcome Kits</li>
              <li className="text-sm text-gray-400">Promotional Merchandise</li>
              <li className="text-sm text-gray-400">Event Giveaways</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4" data-testid="footer-contact-title">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} />
                <a href="mailto:sanket@swifthampers.com" data-testid="footer-email-link" className="hover:text-accent transition-colors">
                  sanket@swifthampers.com
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} />
                <a href="tel:+918169230489" className="hover:text-accent transition-colors">+91 81692 30489</a>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <MapPin size={16} />
                <span>Pan-India Delivery</span>
              </li>
              <li className="flex items-center space-x-2">
                <a href="https://www.linkedin.com/company/swifthampers" data-testid="footer-linkedin-link" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors">
                  <Linkedin size={20} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-400" data-testid="footer-copyright">
            © {new Date().getFullYear()} SwiftHampers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
